// Combine a safe-area inset token with a numeric/string offset into a
// valid CSS calc(). offsetY/offsetX may be a number (px appended) or a
// string (used verbatim).
const withInset = (insetVar, offset) =>
  `calc(${insetVar} + ${typeof offset === 'number' ? `${offset}px` : offset})`;

export const getPlacementTransition = ({
  offsetX,
  offsetY,
  placement,
  transitionType,
}) => {
  if (transitionType === "scale") {
    return scaleTransition(offsetX, offsetY)[placement];
  }

  if (transitionType === "fade") {
    return fadeTransition(offsetX, offsetY)[placement];
  }
};

const scaleMotionProps = {
  initial: {
    opacity: 0,
    transform: "scale(0.75)",
  },
  animate: {
    transform: "scale(1)",
    opacity: 1,
  },
  exit: {
    opacity: 0,
    transform: "scale(0.75)",
  },
};

const fadeMotionProps = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
};

const scaleTransition = (offsetX, offsetY) => {
  return {
    "top-end": {
      default: {
        top: withInset('var(--sat)', offsetY),
        right: offsetX,
      },
      variants: {
        ...scaleMotionProps,
      },
    },
    "top-start": {
      default: {
        top: withInset('var(--sat)', offsetY),
        left: offsetX,
      },
      variants: {
        ...scaleMotionProps,
      },
    },
    "top-center": {
      default: {
        top: withInset('var(--sat)', offsetY),
        left: "50%",
        transform: "translateX(-50%)",
      },
      variants: {
        ...scaleMotionProps,
      },
    },
    "bottom-end": {
      default: {
        bottom: withInset('var(--sab)', offsetY),
        right: offsetX,
      },
      variants: {
        ...scaleMotionProps,
      },
    },
    "bottom-start": {
      default: {
        bottom: withInset('var(--sab)', offsetY),
        left: offsetX,
      },
      variants: {
        ...scaleMotionProps,
      },
    },
    "bottom-center": {
      default: {
        bottom: withInset('var(--sab)', offsetY),
        left: "50%",
        transform: "translateX(-50%)",
      },
      variants: {
        ...scaleMotionProps,
      },
    },
  };
};

const fadeTransition = (offsetX, offsetY) => {
  return {
    "top-end": {
      default: {
        top: withInset('var(--sat)', offsetY),
        right: offsetX,
      },
      variants: {
        ...fadeMotionProps,
      },
    },
    "top-start": {
      default: {
        top: withInset('var(--sat)', offsetY),
        left: offsetX,
      },
      variants: {
        ...fadeMotionProps,
      },
    },
    "top-center": {
      default: {
        top: withInset('var(--sat)', offsetY),
        left: "50%",
        transform: "translateX(-50%)",
      },
      variants: {
        ...fadeMotionProps,
      },
    },
    "bottom-end": {
      default: {
        bottom: withInset('var(--sab)', offsetY),
        right: offsetX,
      },
      variants: {
        ...fadeMotionProps,
      },
    },
    "bottom-start": {
      default: {
        bottom: withInset('var(--sab)', offsetY),
        left: offsetX,
      },
      variants: {
        ...fadeMotionProps,
      },
    },
    "bottom-center": {
      default: {
        bottom: withInset('var(--sab)', offsetY),
        left: "50%",
        transform: "translateX(-50%)",
      },
      variants: {
        ...fadeMotionProps,
      },
    },
  };
};
